<template>
  <div class="about-us-top-block bg--color-01">
    <div class="about-us-top-block__container container-new">
      <div class="about-us-top-block__content">
        <h2
          class="about-us-top-block__title txt--bold txt--30px txt--height-34px txt--color-04 mb-0"
        >
          {{ $t('aboutUs.topBlock.title') }}
        </h2>

        <img
          class="about-us-top-block__book-image"
          width="100%"
          src="@/assets/img/about-us/top-section/main.svg"
          alt="book image"
        >

        <div class="about-us-top-block__info">
          <p
            class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03 mb-32 mb-48--l"
          >
            {{ $t('aboutUs.topBlock.description') }}
          </p>

          <button-with-arrow
            full-width
            size="l"
            :to="localePath('/exchange')"
            class="about-us-top-block__btn"
          >
            {{ $t('aboutUs.topBlock.startTradingBtn') }}
          </button-with-arrow>
        </div>
      </div>

      <div class="about-us-top-block__numbers mt-20 mt-64--m">
        <div
          v-for="(service, index) in services"
          :key="services[service]"
          :to="service.to"
          :href="service.href"
          :target="service.withoutNewTab ? '_self' : '_blank'"
          :class="`about-us-top-block__number-item-${index}`"
          @mouseover="onHoverLink(true, index)"
          @mouseleave="onHoverLink(false, index)"
        >
          <exc-link
            v-if="service.href"
            :href="service.href"
            target="_blank"
            class="about-us-top-block__number-item txt--pointer"
            :class="service.hovered ? service.bgOnHover : 'bg--color-01'"
          >
            <img :src="service.image" :alt="service.service">

            <div class="about-us-top-block__number-item-data">
              <div
                class="about-us-top-block__number-item-rate txt txt--26px txt--34px--l txt--height-34px txt--height-48px--l txt--color-04 txt--bold"
              >
                <number-animation
                  :ref="'service-' + index"
                  :from="0"
                  :to="service.rank || 0"
                  :duration="1.5"
                  :format="
                    v => `${service.withLattice ? '# ' : ''}${v.toFixed(0)}`
                  "
                />
              </div>
              <span
                class="txt txt--16px txt--20px--l txt--height-20px txt--height-30px--l txt--color-04"
              >
                {{ service.service }}
              </span>
            </div>
          </exc-link>
          <div
            v-else
            class="about-us-top-block__number-item"
            :class="service.hovered ? service.bgOnHover : 'bg--color-01'"
          >
            <img :src="service.image" :alt="service.service">

            <div class="about-us-top-block__number-item-data">
              <div
                class="about-us-top-block__number-item-rate txt txt--26px txt--34px--l txt--height-34px txt--height-48px--l txt--color-04 txt--bold"
              >
                <number-animation
                  :ref="'service-' + index"
                  :from="0"
                  :to="service.rank || 0"
                  :duration="1.5"
                  :format="
                    v => `${service.withLattice ? '# ' : ''}${v.toFixed(0)}`
                  "
                />
              </div>
              <span
                class="txt txt--16px txt--20px--l txt--height-20px txt--height-30px--l txt--color-04"
              >
                {{ service.service }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcLink } from '@/components/common'
import { mapState } from 'vuex'
import NumberAnimation from 'vue-number-animation/Number.vue'

export default {
  name: 'AboutUsTopBlock',
  components: {
    NumberAnimation,
    ExcLink,
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
  data () {
    return {
      test0: false,
      test1: false,
      test2: false,
    }
  },
  computed: {
    ...mapState({
      cmcExchangeRank: state => state.globals.cmcExchangeRank || 0,
      cgExchangeRank: state => state.globals.cgExchangeRank || 0,
    }),
    services () {
      return [
        {
          rank: 2014,
          withLattice: false,
          to: this.localePath('/about-us'),
          service: this.$t('welcome.topSection.wasFounded'),
          bgOnHover: 'bg--color-10',
          withoutNewTab: true,
          hovered: true,
          // image: require(`@/assets/icons/welcome/was-founded${
          //   this.test0 ? '-hovered' : ''
          // }.svg`),
          image: require('@/assets/icons/welcome/was-founded-hovered.svg'),
        },
        {
          rank: this.cmcExchangeRank,
          href: 'https://coinmarketcap.com/exchanges/c-patex/',
          withLattice: true,
          service: `${this.$t('welcome.topSection.onService')} CoinMarketCap`,
          bgOnHover: 'bg--color-11',
          hovered: this.test1,
          withoutNewTab: false,
          image: require(`@/assets/icons/welcome/cmc${
            this.test1 ? '-hovered' : ''
          }.svg`),
        },
        {
          rank: this.cgExchangeRank,
          href: 'https://www.coingecko.com/en/exchanges/c_patex',
          withLattice: true,
          service: `${this.$t('welcome.topSection.onService')} CoinGecko`,
          bgOnHover: 'bg--color-09',
          hovered: this.test2,
          withoutNewTab: false,
          image: require(`@/assets/icons/welcome/coingecko${
            this.test2 ? '-hovered' : ''
          }.svg`),
        },
      ]
    },
  },
  methods: {
    onHoverLink (hoverParam, index) {
      this[`test${index}`] = hoverParam
    },
  },
}
</script>

<style lang="scss" scoped>
.about-us-top-block {
  &__container {
    padding-top: toRem(20px);
    padding-bottom: toRem(52px);

    @include bp(l) {
      padding-top: toRem(60px);
      padding-bottom: toRem(96px);
    }
  }

  &__content {
    display: grid;
    grid-template-areas: 'title' 'image' 'info';
    row-gap: toRem(20px);

    @include bp(l) {
      grid-template-areas: 'title image' 'info image';
      grid-template-columns: repeat(2, 1fr);
      row-gap: toRem(24px);
      column-gap: toRem(20px);
    }
  }

  &__title {
    grid-area: title;

    @include bp(m) {
      align-self: flex-end;
    }

    @include bp(l) {
      font-size: toRem(44px);
      line-height: toRem(60px);
    }
  }

  &__book-image {
    grid-area: image;
    max-width: toRem(324.51px);
    margin-left: auto;
    margin-right: auto;

    @include bp(l) {
      max-width: toRem(669px);
      margin: auto 0;
    }
  }

  &__info {
    grid-area: info;

    @include bp(m) {
      align-self: flex-start;
    }
  }

  &__btn {
    @include bp(m) {
      width: fit-content;
    }
  }

  &__numbers {
    display: flex;
    flex-direction: column;
    grid-template-areas: 'first' 'second' 'third';
    gap: toRem(16px);

    @include bp(m) {
      display: grid;
      grid-template-areas: 'first first' 'second third';
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
    }

    @include bp(ml) {
      gap: toRem(24px);
      grid-template-areas: 'first second third';
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 1fr;
    }
  }

  &__number-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: toRem(16px);
    padding: toRem(16px);
    border-radius: toRem(20px);
    box-shadow: 0px 1px 20px 0px #1618220f;
    // min-height: toRem(188px);
    transition-duration: 0.3s;

    img {
      width: toRem(66px);
      height: toRem(66px);
      transition-duration: 0.3s;
    }

    @include bp(m) {
      display: grid;
      grid-template-columns: toRem(100px) 1fr;
    }

    @include bp(l) {
      img {
        width: toRem(100px);
        height: toRem(100px);
      }
    }

    @include bp(ml) {
      gap: toRem(24px);
      padding: toRem(24px) toRem(20px);
    }
  }

  &__number-item-0 {
    grid-area: first;
  }

  &__number-item-1 {
    grid-area: second;
  }

  &__number-item-2 {
    grid-area: third;
  }

  &__number-item-rate {
    background-color: color('transp-03');
    border-radius: toRem(200px);
    padding: toRem(4px) toRem(24px);
    max-width: fit-content;
  }

  &__number-item-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: toRem(12px);

    @include bp(m) {
      justify-content: center;
      align-items: unset;
    }
  }
}
</style>
